export default {
	Language: '繁體中文',
	system: {
		homePage: {
			title1: '標題1',
			title2: '標題2',
			description1: '近7日',
			description2: '近6個月',
		}
	},
	login:{
		register:'註冊會員',
		usernamePls:'請輸入用戶名',
		passwordPls:'請輸入密碼',
		toRegister:'沒有帳號嗎？現在註冊會員吧',
		doLogin:'登入',	  
	},
	register:{
		loginPasswordPls:'請輸入登入密碼',
		repasswordPls:'請再次輸入登入密碼',
		passwordMismatch:'兩次輸入的登入密碼不一致',
		codePls:'請輸入邀請代碼',  
		register:'註冊',
		xieyi:'同意使用條款',
		xieyiPls:'請選擇下面的開戶協議！',
	},
	mine:{
		xyfs:'信用評分',
		ljjf:'累積積分',
		recharge:'積分儲值',
		withdraw:'積分提款',
		money:'擁有的積分',
		infomation:'基本資訊',
		moneylog:'積分記錄',
		withdrawrecord:'提款歷史',
		gamerecord:'歷史記錄',
		notice:'通知',
		mymove:'查看歷史記錄',
		loginpwd:'登錄密碼',
		paypwd:'資金管理',
		loginout:'註銷',
		paypwdhasseted:'已設定取款密碼。如果需要修改，請與客戶中心聯繫',
		setbank:'請設定收款卡！',
		lorr:'登入/註冊',
	},
	infomation:{
		username:'會員ID',
		name:'姓名',
		bankcard:'提款帳戶',
		phone:'手機號碼',
		recharge:'充值',
		amount:'擁有點',
		toserve:'請聯繫客戶服務',
		kfms:'想要線下充電，請向客服諮詢。部分結算渠道的充值金額將隨機充值至小數點1位，結算時請務必確認',
	},
	withdraw:{
		title:'提現',
		log:'取款記錄',
		method:'取款方法',
		avmoney:'可提現餘額',
		limit:'取款限度',
		submit:'提款申請',
		xiane:'單筆限額',
		numbers:'取款次數',
		time:'到帳時間',
		zuidi:'最少',
		zuigao:'最高',
		numsmax:'每天最多提取現金',
		ci:'次',
		timedetail:'一般匯款時間為5分鐘左右，最快在2分鐘內匯款',
		bank:'銀行卡',
		status1:'待審核',
		status2:'成功',
		status3:'失敗',
		enterCorrectAmount: '請填寫正確的金額',
		selectBankCard: '請選擇提現銀行卡',
		enterPayPassword: '請輸入支付密碼',
	},
	moneylog:{
		title:'資金明細',
		type1:'變更',
		type2:'彩金',
		type3:'任務',
		type4:'獎金',
		type5:'取款',
		type6:'取款失敗',
		rechargeNote: '（充值）',
	},
	setting:{
		loginpwdtitle:'更改登入密碼',
		oldpwd:'請輸入舊密碼',
		newpwd:'請輸入新密碼',
		renewpwd:'請重新輸入新密碼',
		change:'更改',
		plseall:'請填寫完整表格！',
		pswwrong:'兩次密碼輸入不匹配',
		paypwdtitle:'設定資金密碼',
		paypwd:'請輸入資金密碼',
		repaypwd:'請重新輸入資金密碼',
		title: '設定',
		basicInfo: '基本資訊設定',
		loginPassword: '登入密碼',
		fundPassword: '資金密碼',
		logout: '退出登入',
		payPasswordSet: '提現密碼已設定，需要修改請聯繫客服',
		payPasswordNotSet: '未設定',
		payPasswordHasSet: '已設定',
		confirm: '確認',
	},
	home:{
		gonggao:'享受終極奢華體驗',
		qgkf:'全國可能',
		hotlist:'人氣推薦列表',
		hotgame:'任務推薦',
		gaoji:'高級',
		smrz:'實地認證',
		videorz:'本人影片認證',
		star:'評分',
		sg:'身高',
		xw:'胸圍',
		diqu:'可服務區域',
		apply:'申請約會',
		ssxz:'即時現狀',
		joinvip:'加入了會員',
	},
	video:{
		title:'視訊聽',
		nums:'播放量',
		bofangliang:'播放量',
		hotlist:'人氣推薦',
		plsrefisrt:'請充值後看影片！',
	},
	choose:{
		title:'最好的一夜',
		nav:'選妃',
		apply:'匹配申請',
		jianjie:'美女簡介',
		move:'是否可移動',
		click:'點擊認證',
		detail:'詳細資訊',
		videodetail:'即時影片',
	},
	common:{
		refresh:'重新整理成功',
		noallow:'功能已停用！',
		disable:'停用',
		all:'全部',
		nomore:'沒有更多了',
		nodata:'無資料',
		submit:'提交',
		more:'查看更多',
		pinglunnav:'評論',
		pingluntitle:'評論',
		pldtitle:'評論詳情',
		minenav:'帳戶',
		homenav:'主頁',
		addbank:'新增收款卡',
		setbank:'提款帳戶',
	},
	game:{
		expect:'期號',
		jieguo:'數據',
		da:'大',
		xiao:'小',
		dan:'單',
		shuang:'雙',
		/** 激情四射（原大小單雙） */
		激:'激',
		四:'四',
		射:'射',
		意:'意',
		亂:'亂',
		情:'情',
		迷:'迷',
		大:'大',
		小:'小',
		单:'單',
		双:'雙',
		order:'任務單',
		clear:'清空訂單',
		submit:'確認提交',
		kjcc:'開獎成功，期號：',
		lxgly:'請與您的管理員聯繫',
		plsmoney:'請填寫金額!',
		plsnum:'請選擇號碼!',
		moneynote:'餘額不足，請聯繫客服充值!',
		lefttime:'剩餘時間',
		lunci:'期號',
		workRecord: '任務記錄',
		day: '日',
		period: '期',
		allWork: '所有任務',
		reset: '重置',
		confirm: '確認',
		bonusPoints: '獎勵積分',
		missionMoney: '任務金額明細',
		missionResult: '任務結果',
		points: '積分',
		workPoints: '任務積分',
		giftCompleted: '禮品已完成',
		orderTime: '訂單時間：',
		detail: '詳情',
		content: '內容',
		amount: '金額',
		result: '結果',
		time: '時間',
		win: '獲勝',
		missionFailed: '任務失敗',
	},
	kefu:{
		title:'線上客服',
		lianxi:'聯繫',
		content:'全天7 * 24小時竭誠為您服務',
		defaultName: '線上客服',
	},
	setname:{
		title:'修改實名',
		xingming:'名字',
		tips:'為了您的帳戶安全，實際名稱必須與綁定銀行卡名稱匹配',
		xmpls:'請輸入實際名稱',
		save:'保存',
		notreset:'不要重複設定！',
		plsentername:'請輸入名稱！',
	},
	withdrawCenter: '提現中心',
	withdrawRecord: '提現記錄',
	withdrawAmount: '提現金額',
	allMoney: '全部',
	singleLimit: '單筆限額',
	lowest: '最低',
	highest: '最高',
	withdrawTimes: '提現次數',
	maxDailyWithdraw: '一天最高提現',
	times: '次',
	arrivalTime: '到帳時間',
	limitDescription: '限額說明',
	balance: '餘額',
	withdrawNow: '馬上提現',
	enterCorrectAmount: '請填寫正確的金額',
	personalReport: '個人報表',
	profitAmount: '盈利金額',
	profitFormula: '盈利計算公式 : 中獎金額 - 任務金額',
	taskAmount: '任務金額',
	accountOffline: '帳號下線',
	loginRegister: '登入/註冊',
	loginForMore: '登入可享受更多服務！',
	author: '作者:',
	notification: '通知',
	changePhone: '修改手機號',
	save: '保存',
	existingPhone: '現有手機號',
	newPhone: '新手機號',
	withdrawAccountRegister: '提款帳戶註冊',
	selectBankCard: '請選擇銀行卡',
	accountNumber: '帳戶號碼',
	enterBankCardNumber: '請輸入銀行卡號碼',
	systemNotice: '系統通知',
	myMovie: '我的電影',
	completeTaskForMore: '完成任務以獲得更多電影票',
	movieTicket: '電影票:',
	watchList: '觀看列表',
	noDataYet: '暫無資料',
	setNameFirst: '請先設定姓名後再關聯提款帳戶！',
	setPasswordFirst: '請先設定提現密碼後再綁定銀行卡！',
	accountHolder: '帳戶持有人',
	enterRealName: '請輸入真實姓名',
	withdrawPassword: '提款密碼',
	registerWithdrawPassword: '請註冊提款密碼',
	bankCard: '銀行卡',
	orderContentLabel: '訂單內容:',
	all: '全部',
	bonusPointsLabel: '獎勵積分',
	waitingResultLabel: '等待結果',
	missionMoneyDetails: '任務金額明細',
	points: '積分',
	switch: '開關',
	currentSelection: '當前選擇:',
	quantity: '數量:',
	total: '總計',
	ticketUnit: '票',
	ticketAmount: '總數量',
	availablePoints: '可用積分',
	verify: '驗證',
	possible: '可能',
	thumb: '拇指',
	privacyPolicy: '隱私政策',
	romanticDescription: 'Gentle Meet 為了保護會員的個人資訊，透過實名認證服務完成認證或透過已完成認證的會員推薦才能註冊。',
	person1: '夏雨',
	person2: '敏雪',
};
